import { applyMiddleware, compose, createStore } from 'redux'
import { createEpicMiddleware } from 'redux-observable';

import reducers from '../reducers'
import epics from '../epics'

const epicMiddleware = createEpicMiddleware(epics)
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
  reducers,
  composeEnhancers(applyMiddleware(epicMiddleware))
)



/** WEBPACK FOOTER **
 ** ./src/store/index.js
 **/